import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RadioInactive from '@parchment/ui-icons/lib/ai/radio-button';
import RadioActive from '@parchment/ui-icons/lib/ai/radio-active';

var Option = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Option, _Component);

  _createClass(Option, null, [{
    key: "propTypes",
    get: function get() {
      return {
        id: PropTypes.string,
        panelId: PropTypes.string,
        className: PropTypes.string,
        icon: PropTypes.node,
        iconSelected: PropTypes.node,
        label: PropTypes.node,
        enabled: PropTypes.bool,
        selected: PropTypes.bool,
        onClick: PropTypes.func,
        displayRadioButtons: PropTypes.bool,
        displayDivider: PropTypes.bool,
        optionDescription: PropTypes.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        enabled: true,
        panelId: 'tabPanel',
        className: 'search-or-create-option',
        displayRadioButtons: true,
        displayDivider: true
      };
    }
  }]);

  function Option(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleOnClick = _this.handleOnClick.bind(_assertThisInitialized(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Option.prototype;

  _proto.handleOnClick = function handleOnClick(e) {
    if (this.props.enabled) {
      this.props.onClick(this.props.id, e);
    }
  };

  _proto.handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleOnClick(e);
    }
  };

  _proto.renderOptionDescription = function renderOptionDescription() {
    return /*#__PURE__*/React.createElement("div", {
      className: "option-description"
    }, this.props.optionDescription);
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.className,
      onClick: this.handleOnClick,
      role: "tab",
      tabIndex: "0",
      "aria-disabled": this.props.enabled ? 'false' : 'true',
      "aria-selected": this.props.selected ? 'true' : 'false',
      "aria-controls": this.props.panelId,
      id: this.props.id,
      onKeyPress: this.handleKeyPress
    }, this.icon, this.radioButton, this.props.selected && this.props.enabled && /*#__PURE__*/React.createElement("div", {
      className: "option-down-arrow",
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("div", {
      className: "option-label"
    }, this.props.label), this.props.optionDescription && this.renderOptionDescription());
  };

  _createClass(Option, [{
    key: "icon",
    get: function get() {
      return this.props.selected && this.props.enabled ? this.props.iconSelected : this.props.icon;
    }
  }, {
    key: "radioButton",
    get: function get() {
      return this.props.selected && this.props.enabled ? /*#__PURE__*/React.createElement(RadioActive, {
        "aria-hidden": "true"
      }) : /*#__PURE__*/React.createElement(RadioInactive, {
        "aria-hidden": "true"
      });
    }
  }, {
    key: "displayRadioButtons",
    get: function get() {
      return "" + (!this.props.displayRadioButtons ? ' hide-radio-button' : '');
    }
  }, {
    key: "displayDivider",
    get: function get() {
      return "" + (!this.props.displayDivider ? ' hide-divider' : '');
    }
  }, {
    key: "className",
    get: function get() {
      return "option" + (this.props.selected ? ' option-selected' : '') + (this.props.enabled ? '' : ' option-disabled') + " " + this.props.className + " " + this.displayRadioButtons + " " + this.displayDivider;
    }
  }]);

  return Option;
}(Component);

export { Option as default };